import * as tpa from '@/tpa';
import type { EditorAPI } from '@/editorAPI';
import type {
  MapDispatchToPropsFunction,
  MapStateToProps,
  ThunkAction,
} from 'types/redux';
import type {
  GroupsWelcomeDispatchProps,
  GroupsWelcomeOwnProps,
  GroupsWelcomeStateProps,
} from './types';
import {
  EditorType,
  InstallationOriginType,
  InstallInitiator,
} from '@wix/platform-editor-sdk';

export const mapStateToProps: MapStateToProps<
  GroupsWelcomeStateProps,
  GroupsWelcomeOwnProps
> = ({ editorAPI }) => ({
  welcomeSectionTemplate: editorAPI.addPanelInfra.welcomeSection,
});

const getEditorAPI: ThunkAction<EditorAPI> = (
  dispatch,
  getState,
  { editorAPI },
) => editorAPI;

export const mapDispatchToProps: MapDispatchToPropsFunction<
  GroupsWelcomeDispatchProps,
  GroupsWelcomeOwnProps
> = (dispatch) => {
  const editorAPI = dispatch(getEditorAPI);

  return {
    installGroupsApp: () =>
      tpa.superApps.addApp(tpa.superApps.superAppsConstants.GROUPS.APP_DEF_ID, {
        biOrigin: tpa.constants.BI.type.ADD_APP_APP_BUTTON,
        platformOrigin: {
          type: EditorType.Classic,
          initiator: InstallInitiator.Editor,
          info: {
            type: InstallationOriginType.AddPanel,
          },
        },
        callback: (data: AnyFixMe) => {
          const pageId = data?.page?.id;
          if (pageId) {
            editorAPI.pages.navigateTo(pageId, () => {
              const sectionPointer =
                tpa.superApps.getSectionRefByPageId(pageId);
              editorAPI.selection.selectComponentByCompRef(sectionPointer);
            });
          }
        },
      }),
  };
};
